import { Navigate } from "react-router-dom";
import { getRole, getIsSubscribed } from "../utils/auth";
import ROLES from "../utils/constants";

const ProtectedRoute = ({
  children,
  allowedRoles,
}: {
  children: JSX.Element;
  allowedRoles: string[];
}) => {
  const role = getRole();
  const isSubscribed = getIsSubscribed();

  if (!role) {
    return <Navigate to="/login" replace />;
  }

  if (role === ROLES.TENANT_ADMIN && !isSubscribed) {
    return <Navigate to="/subscription" replace />;
  }

  if (!allowedRoles.includes(role)) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
